export enum JobStatus {
  DRAFT = 'draft',
  RECRUITING = 'recruiting',
  QUEUED = 'queued',
  REALIZATION = 'realization',
  FINISHED = 'finished',
  COLLECTED = 'collected',
  PAID = 'paid',
  CANCELLED = 'cancelled',
  DELETED = 'deleted',
  SKIPPED = 'skipped',
  FAILED = 'failed'
}
